import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import paths from 'paths';
import { dt, getLocale } from 'l10n';
import { getMessageText } from 'utils/notifications';
import { formatUnixDateDMY } from 'utils/formatDate';
import { Link } from 'components/ReactRouterDomLocalized';
import { isSameRoomURL, addHashParam as addURLHashParam } from 'utils/url';

const ItemPopupNotification = ({ data, count, closeToast, history }) => {
    const { type, data: { meta }} = data;

    const onProfileClick = (e, nick) => {
        e.preventDefault();
        history.push(paths.profile.toPath({ nick }));
    };

    const onMoreClick = e => {
        e.preventDefault();
        history.push(paths.memberNotificationList.path);
    };

    const fr = getLocale() === 'fr';

    const externalLink = (type === "followed_user_is_online" || type === "new_personal_room" || type === "new_showroom");

    let nick;
    if (externalLink) {
        nick = typeof  meta.user === 'undefined' ? meta.creator.nick : meta.user.nick;
    }

    const isWall = type === "wall";
    const isGift = type === "gift";
    const isPmMessage = type === "pm_message";
    if (isPmMessage) {
        count = 0;
    }
    const withUrl = ['wall', 'gift', 'message', 'pm_message', 'guestbook_message', 'user_membership_expired', 'user_membership_almost_expired']
        .indexOf(type) !== -1;

    const maybeOpenRoom = url => {
        let wnd = window.open('', 'chat', 'height=678,width=1200,resizable=1,toolbar=0,scrollbars=0');

        const ufrag = type === "followed_user_is_online" ?  meta.user.ufrag : null;

        // if we just opened the window
        if (wnd.closed || (!wnd.document.URL) || (wnd.document.URL.indexOf("about") === 0) || !isSameRoomURL(url, wnd.document.URL)) {
            if (meta.user && meta.user.ufrag) {
                wnd.location.href = addURLHashParam(url, "u", btoa(meta.user.ufrag));
            } else {
                wnd.location.href = url;
            }
        } else {
            wnd.focus();
            wnd.postMessage({action: 'openVideoWindow', ufrag, roomid: meta.user.roomid}, "*");
        }

        // return the window
        return wnd;
    };

    return (
        <div className={`notification-item ${type === 'wall' ? "autowidth" : ""}`}>
            {externalLink ? (
                <div onClick={e => maybeOpenRoom(meta.room.url)} className="item">
                    <div className="action">
                        <div className="username" onClick={e => onProfileClick(e)}>{nick}</div>
                        {dt('notifications', getMessageText(type))}
                        <div className="username margin-left">{meta.room.name}</div>
                    </div>
                </div>
            ) : (
                <Link className="item" to={withUrl ? meta.url : paths.memberNotificationList.path}>
                    {(type === "tip" || type === "new_follower" || type === "guestbook_message") && (
                        <div className="action">
                            {!fr && dt('notifications', getMessageText(type), meta.amount)}
                            <div className={`username ${fr ? '' : 'margin-left'}`} onClick={e => onProfileClick(e,meta.user.nick)}>{meta.user.nick}</div>
                            {fr && dt('notifications', getMessageText(type),  meta.amount)}
                        </div>
                    )}

                    {(type === "message" || type === "membership_gift") && (
                        <div className="action">
                            <div className="username" onClick={e => onProfileClick(e, meta.user.nick)}>{meta.user.nick}</div>
                            {dt('notifications', getMessageText(type),  meta.duration)}
                        </div>
                    )}

                    {type === "membership_gift_public" && (
                        <div className="action">
                            <div className="username" onClick={e => onProfileClick(e, meta.sender.nick)}>{meta.sender.nick}</div>
                            {dt('notifications', getMessageText(type))}
                            <div className="username margin-left" onClick={e => onProfileClick(e, meta.recipient.nick)}>{meta.recipient.nick}</div>
                        </div>
                    )}

                    {(type === "user_membership_expired" || type === "user_membership_almost_expired") && (
                        <div className="action">
                            {dt('notifications', getMessageText(type), formatUnixDateDMY(meta.expiration_date))} {dt('notifications', 'Renew now!')}
                        </div>
                    )}
    
                    {type === "stream_record_error" && (
                      <div className="action">
                          {dt('notifications', getMessageText(type))}
                      </div>
                    )}

                    {(isGift || isWall) && (
                        <div className="action flex">
                            <img className={`image ${isWall ? 'maxWidth' : ''}`} src={isWall ? meta.material.thumbnail :  meta.gift.img} />
                            <div className="message-wrapper">
                                <div  className={meta.user.id === 0 ? "username username_anonymous" : "username"} onClick={e => onProfileClick(e, meta.user.nick)}>{meta.user.nick}</div>
                                {dt('notifications', getMessageText(type))}
                            </div>
                        </div>
                    )}

                    {(isPmMessage) && (
                        <div className="action flex">
                            {meta.image && <img className={'image maxWidth'} src={meta.image} />}
                            <div className="message-wrapper">
                                <div className="username" onClick={e => onProfileClick(e, meta.user.nick)}>{meta.user.nick}</div>
                                {dt('notifications', getMessageText(type))}

                                <div className="text">{meta.text}</div>
                                
                            </div>
                        </div>
                    )}
                    {!!count && <div className="more" onClick={onMoreClick}>{dt('notifications', 'See all')} ({++count})</div>}
                </Link>
            )}
            <div className={`icon-close ${(isWall || isGift) ? 'round' : ''}`} onClick={closeToast} />
        </div>
    )
};

ItemPopupNotification.propTypes = {
    data: PropTypes.object.isRequired,
    count: PropTypes.number.isRequired,
    history: PropTypes.object.isRequired,
    currentUser: PropTypes.object.isRequired,
    closeToast: PropTypes.func,
};

const mapStatetoProps = state => ({
    currentUser: state.currentUser,
    count: state.memberNotificationList.list.length,
});

export default connect(mapStatetoProps)(withRouter(ItemPopupNotification));



// WEBPACK FOOTER //
// ./src/components/notification/ItemPopupNotification.js